const blacklist = [
  "BA_KYA_INTOUCH-TOTAL",
  "KYA_INTOUCH",
  "Allowed KYC Type",
  "BA_KYA_INTOUCH-TOTAL",
  "BA_KYA_INTOUCH",
  "KYA_TAPTAP_SEND",
  "BA_KYA_ZEEPAY",
  "BA_KYA_DER",
  "BA_KYA_BETONELINE",
  "BA_KYA_HKPG",
  "BA_KYA_BELMONEY",
  "BA_KYA_WELLIE",
  "BA_KYA_UNIPAY",
  "KYA_INTOUCH",
  "KYA_INTOUCH-TOTAL",
  "BA_KYA_ONYX",
  "BA_KYA_ATPS",
  "BA_KYA_CASH_XPRESS",
  "BA_KYA_BG DIGIT",
  "BA_KYA_CAPITAL SERVICES",
  "KYA_BG DIGIT",
  "BA_KYA_AZA",
  "BA_KYA_TAPTAP_SEND",
  "BA_KYA_PATISEN",
  "BA_KYA_SOFTGAL",
  "BA_KYA_OMNEX.BASN",
  "KYA AMIFA WIZALL B2W",
  "KYA_PAYDUNYA",
  "KYA_BASN",
  "DANAYA FINAO",
  "KYA_WAVE",
  "KYA_NUMHERIT",
  "KYA_Kuasar",
  "KYA_Worldremit",
  "KYA_PAYPOS",
  "KYA_TMC",
  "KYA_PAYDUNIA",
  "KYA_OOLU",
  "KYA_APG_FULL",
  "KYA_HEXING",
  "BA_KYA_SMART DIGITAL",
  "BA_KYA_CILIAM",
  "BA_KYA_SEMOA",
  "BA_KYA_RELOADLY",
  "BA_KYA_LONASE",
  "BA_KYA_SMALL WORLD",
  "BA_KYA_INTECH",
  "BA KYA INTOUCH API",
];

export default blacklist;
